import { Popover, styled } from '@mui/material';

export const HBPopoverRootStyle = styled(Popover)(({}) => ``);
